import Immutable from 'immutable'
import moment from 'moment'

export const ExtraRecord = Immutable.Record({
  allowanceDownloadOffpeak: null, // Bandwidth Pack
  allowanceDownloadPeak: null, // Bandwidth Pack
  allowanceUploadOffpeak: null, // Bandwidth Pack
  allowanceUploadPeak: null, // Bandwidth Pack
  description: '',
  interval: null,
  iterations: 0,
  nextInvoice: null,
  nextPeriod: null,
  price: 0,
  quantity: 1,
}, 'ServiceExtra')

export default function createServiceExtra({
  allowance_download_offpeak,
  allowance_download_peak,
  allowance_upload_offpeak,
  allowance_upload_peak,
  interval,
  iterations,
  next_invoice,
  next_period,
  price,
  quantity,
  ...data
}) {
  /* eslint-disable camelcase */
  return new ExtraRecord({
    allowanceDownloadOffpeak: allowance_download_offpeak ? parseInt(allowance_download_offpeak, 10) : null,
    allowanceDownloadPeak: allowance_download_peak ? parseInt(allowance_download_peak, 10) : null,
    allowanceUploadOffpeak: allowance_upload_offpeak ? parseInt(allowance_upload_offpeak, 10) : null,
    allowanceUploadPeak: allowance_upload_peak ? parseInt(allowance_upload_peak, 10) : null,
    interval: interval ? moment.duration(interval) : null,
    iterations: parseInt(iterations, 10),
    nextInvoice: next_invoice ? moment(next_invoice) : null,
    nextPeriod: next_period ? moment(next_period) : null,
    price: parseFloat(price),
    quantity: parseInt(quantity, 10),
    ...data,
  })
  /* eslint-enable camelcase */
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Extra.js